export const STRIPE_SCRIPT_VERSION = 'v3';
export const BRAINTREE_SCRIPT_VERSION = '3.58.0';
